import {
  AUDIO_TRANSCRIPTION_NO_REALTIME_PROVIDERS,
  AUDIO_TRANSCRIPTION_REALTIME_PROVIDERS,
} from "@/common/config";
import type { TranscriptionProviderOption } from "@/common/types/types";
import {
  TranscriptionNoRealtimeProviderName,
  TranscriptionProviderName,
} from "@/hooks/transcriber/types";
import { useRecordingSettingsStore } from "@/store/recordingSettings.store";

export const useSelectTranscriptionProvider = (): {
  value: string;
  values: TranscriptionProviderOption[];
  handleChange: (value: string) => void;
} => {
  const {
    transcriptionProvider,
    saveTranscriptionProvider,
    isRealtimeEnabled,
    transcriptionNoRealtimeProvider,
    saveTranscriptionNoRealtimeProvider,
  } = useRecordingSettingsStore();

  const handleChange = (value: string): void => {
    if (isRealtimeEnabled) {
      if (
        AUDIO_TRANSCRIPTION_REALTIME_PROVIDERS.some((p) => p.value === value)
      ) {
        saveTranscriptionProvider(value as TranscriptionProviderName);
      } else {
        saveTranscriptionProvider(TranscriptionProviderName.OPENAI);
      }
    } else {
      if (
        AUDIO_TRANSCRIPTION_NO_REALTIME_PROVIDERS.some((p) => p.value === value)
      ) {
        saveTranscriptionNoRealtimeProvider(
          value as TranscriptionNoRealtimeProviderName,
        );
      } else {
        saveTranscriptionNoRealtimeProvider(
          TranscriptionNoRealtimeProviderName.DEEPGRAM_NOVA_3_MEDICAL,
        );
      }
    }
  };

  const values = isRealtimeEnabled
    ? AUDIO_TRANSCRIPTION_REALTIME_PROVIDERS
    : AUDIO_TRANSCRIPTION_NO_REALTIME_PROVIDERS;

  const value = isRealtimeEnabled
    ? transcriptionProvider
    : transcriptionNoRealtimeProvider.startsWith("elevenlabs")
      ? TranscriptionNoRealtimeProviderName.DEEPGRAM_NOVA_3_MEDICAL
      : transcriptionNoRealtimeProvider;

  return {
    value,
    values,
    handleChange,
  };
};
